module.exports = __webpack_public_path__ + "img/1280.9e8f0f9c.svg";